import { Reducer } from 'redux';
import { update } from '../helpers/immutabilityHelper'
import * as Dtos from '../dtos/Tmd.dtos';

import {
    NoteTypeNotesActions,
    ACTION_NOTETYPENOTES_LOAD_BY_TRIALID,
    ACTION_NOTETYPENOTES_LOAD_BY_TRIALINSTITUTIONID,
    ACTION_NOTETYPENOTES_LOAD_BY_INSTITUTIONID,
    ACTION_NOTETYPENOTES_LOAD_SUCCESS,
    ACTION_NOTETYPENOTES_LOAD_FAILURE,
    ACTION_NOTETYPENOTES_CLEAR,
    ACTION_NOTETYPENOTES_FILTER,
    ACTION_NOTETYPENOTES_LOAD_BY_PERSONNELID,
} from '../actions/noteTypeNotes';
import { RequestState } from "../enumerations/RequestState";
import { IRequestState, IFormFilter } from "./index";
import { updateFailureIndexToId } from "../helpers/formErrorHelper";

export interface INoteTypeNotesState {
    formData: Dtos.NoteTypeNotes[],
    lookups: Dtos.Lookup[],
    loadState: IRequestState;
    formFilter: IFormFilter;
    formFilteredData: Dtos.NoteTypeNotes[];
    formLength: number;
}

const initialState: INoteTypeNotesState = {
    formData: undefined,
    lookups: undefined,
    loadState: {
        status: RequestState.None
    } as IRequestState,
    formFilter: {
        search: "",
        showInActive: false
    },
    formFilteredData: [],
    formLength: 0
};


function loading(state: INoteTypeNotesState, _isLoading: boolean): INoteTypeNotesState {
    const newState: INoteTypeNotesState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function loadSuccess(
    state: INoteTypeNotesState,
    formData: Dtos.NoteTypeNotes[],
    lookups: Dtos.Lookup[],
    responseStatus: Dtos.ResponseStatus
): INoteTypeNotesState {
    const newState: INoteTypeNotesState = update(state, {
        formData: {
            $set: formData
        },
        lookups: {
            $set: lookups
        },
        loadState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return filter(newState, state.formFilter);
}

function filter(state: INoteTypeNotesState, formFilter: IFormFilter): INoteTypeNotesState {

    const noteTypeNotes: Dtos.NoteTypeNotes[] | undefined =
        state.formData instanceof Array ?
            state.formData :
            undefined;

    const formLength = noteTypeNotes ? noteTypeNotes.length : 0;

    const formFilteredData = noteTypeNotes ? noteTypeNotes.filter(p => (formFilter.showInActive) &&
        (formFilter.search == "" || p.noteType.value.toLowerCase().indexOf(formFilter.search.toLowerCase()) > -1)) : undefined;

    const newState: INoteTypeNotesState = update(state, {
        formFilter: {
            $set: formFilter
        },
        formFilteredData: {
            $set: formFilteredData
        },
        formLength: {
            $set: formLength
        }
    });

    return newState;
}

function loadFailure(state: INoteTypeNotesState, responseStatus: Dtos.ResponseStatus): INoteTypeNotesState {
    const newState: INoteTypeNotesState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function clear(state: INoteTypeNotesState, propertiesToClear?: string[]): INoteTypeNotesState {

    if (!propertiesToClear) {
        const newState: INoteTypeNotesState = update(initialState, {});
        return newState;
    }

    let stateModifier: any = {};

    propertiesToClear.forEach(propertyToClear => {
        stateModifier[propertyToClear] = { $set: initialState[propertyToClear] }
    });

    const newState = update(state, stateModifier);

    return newState;
}

const NoteTypeNotesReducer: Reducer<INoteTypeNotesState> = (state: INoteTypeNotesState = initialState, action: NoteTypeNotesActions) => {
    switch (action.type) {
        case ACTION_NOTETYPENOTES_LOAD_BY_TRIALID:
        case ACTION_NOTETYPENOTES_LOAD_BY_TRIALINSTITUTIONID:
        case ACTION_NOTETYPENOTES_LOAD_BY_INSTITUTIONID:
        case ACTION_NOTETYPENOTES_LOAD_BY_PERSONNELID:
            return loading(state, true);
        case ACTION_NOTETYPENOTES_LOAD_SUCCESS:
            return loadSuccess(state, action.formData, action.lookups, action.responseStatus);
        case ACTION_NOTETYPENOTES_LOAD_FAILURE:
            return loadFailure(state, action.responseStatus);
        case ACTION_NOTETYPENOTES_CLEAR:
            return clear(state, action.propertiesToClear);
        case ACTION_NOTETYPENOTES_FILTER:
            return filter(state, action.formFilter);
    }

    return state;
}

export default NoteTypeNotesReducer;